module.exports = __webpack_public_path__ + "static/media/corporate-advisory.b41f9bec.webp";